import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { isInternal, isProjectReadOnlyRole } from "../../redux/actions/userAction";
import RequestFeed from "../LenderRequests/RequestFeed/RequestFeed";
import ContextAwareToggle from "../Profile/ContextAwareToggle";
import { CPM_REQUEST_GRID_INTERNAL } from "../shared/constants/FeatureToggleKeys";
import { REQUEST_STATUSES } from "../shared/constants/RequestStatuses";
import useFeatureFlags from "../shared/services/featureToggle/useFeatureFlags";
import { getLenderRequestsByProject } from "../shared/services/LenderRequestService";

const ProjectErrorPage = ({ match }) => {
  const projectId = match?.params?.project_id;
  const { isFeatureEnabled } = useFeatureFlags([CPM_REQUEST_GRID_INTERNAL]);
  const [requests, setRequests] = useState([]);

  const canShowFeed = (isInternal() || isProjectReadOnlyRole()) && isFeatureEnabled(CPM_REQUEST_GRID_INTERNAL);

  const fetchRequests = useCallback(async () => {
    if (!canShowFeed || !projectId) {
      setRequests([]);
      return;
    }
    try {
      const all = (await getLenderRequestsByProject(projectId)) || [];
      const filtered = all.filter(
        r => r.externalStatus !== REQUEST_STATUSES.DRAFT && r.statusName !== REQUEST_STATUSES.DRAFT
      );
      setRequests(filtered);
    } catch (err) {
      console.error("Failed to fetch requests for deleted project", err);
      setRequests([]);
    }
  }, [canShowFeed, projectId]);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const markRequestRead = (requestId) => {
    const passData = JSON.parse(sessionStorage.getItem("passData"));
    const userId = passData?.user;
    axios
      .post(global.REACT_APP_API_ENDPOINT + `/condoMgr/markViewed/requestfeed/${requestId}/${userId}`)
      .catch(err => {
        console.error('markRequestRead failed', { requestId, error: err.message });
      });
    setRequests(prev => prev.map(r => (r.requestId === requestId ? { ...r, isRead: true } : r)));
  };

  return (
    <>
      <Card className="accordion-header-card" style={{ margin: "32px 66px" }}>
        <Card.Body
          style={{
            fontSize: 20,
            textAlign: "center",
            padding: 40,
            fontWeight: "bold",
            color: "#212529",
          }}
        >
          This project record has been deleted. Please contact{" "}
          <span className="card-text card-text-body">
            <a href="mailto:cpm_manage@fanniemae.com">cpm_manage@fanniemae.com</a>
          </span>{" "}
          with any questions or concerns.
        </Card.Body>
      </Card>
      {requests.length > 0 && (
        <Accordion defaultActiveKey="0">
          <Card className="accordion-header-card">
            <Card.Header className="accordion-header-space">
              <ContextAwareToggle eventKey="0">
                <p className="accordion-header-title">Request Feed</p>
              </ContextAwareToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body className="accordion-body-card request-body-card">
                <RequestFeed
                  requests={requests}
                  projectInfo={{}}
                  projectRestrictions={[]}
                  isProjectDeleted={true}
                  onRefresh={fetchRequests}
                  onExpand={markRequestRead}
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
    </>
  );
};

export default ProjectErrorPage;

